<template>
    <BModal
        :model-value="modal"
        centered
        @update:modelValue="updateModal"
        scrollable
        no-close-on-backdrop
    >
        <template #header>
            <div
                class="d-flex align-items-center justify-content-between modal-title w-100"
            >
                <h5 class="">Accomodation</h5>
                <BButton
                    variant="link"
                    class="close"
                    @click="updateModal(false)"
                >
                    <i class="ion ion-android-close"></i>
                </BButton>
            </div>
        </template>

        <BForm @submit.stop.prevent>
            <BRow>
                <BCol>
                    <BFormGroup
                        label="Destination *"
                        label-for="destination"
                        class="text-start mb-3"
                    >
                        <v-select
                            v-model="form.destination_uuid"
                            label="name"
                            :options="destinationList"
                            :reduce="(item) => item.uuid"
                            :searchable="true"
                            :clearable="true"
                            taggable
                            placeholder="Select Destination"
                            :class="{
                                'is-invalid':
                                    v$.form.destination_uuid.$dirty &&
                                    v$.form.destination_uuid.$invalid,
                            }"
                        />
                        <BFormInvalidFeedback
                            :state="
                                v$.form.destination_uuid.$dirty &&
                                v$.form.destination_uuid.$invalid
                            "
                        >
                            {{ v$.form.destination_uuid.$errors[0]?.$message }}
                        </BFormInvalidFeedback>
                    </BFormGroup>
                </BCol>
            </BRow>

            <BRow>
                <BCol>
                    <BFormGroup
                        label="Accomodation"
                        label-for="accomodation"
                        class="text-start mb-3"
                    >
                        <v-select
                            v-model="selectedAccomodation"
                            label="name"
                            :options="accomodationList"
                            :reduce="(item) => item.uuid"
                            :searchable="true"
                            :clearable="true"
                            taggable
                            :loading="accomodationLoading"
                            @open="getAllAccomodation"
                            @option:selected="getAccomodation"
                            :create-option="
                                (name) => ({
                                    uuid: `new-${Date.now()}`,
                                    name: name,
                                    code: '',
                                })
                            "
                            placeholder="Name *"
                            :class="{
                                'is-invalid':
                                    v$.form.name.$dirty &&
                                    v$.form.name.$invalid,
                            }"
                        >
                            <template v-slot:no-options="{ search }">
                                <span v-if="search"> </span>
                                <span v-else>
                                    <small class="text-muted">
                                        Type and press <strong>Enter</strong> to
                                        add a new item.
                                    </small>
                                </span>
                            </template>
                        </v-select>
                        <BFormInvalidFeedback
                            :state="
                                v$.form.name.$dirty && v$.form.name.$invalid
                            "
                        >
                            {{ v$.form.name.$errors[0]?.$message }}
                        </BFormInvalidFeedback>
                    </BFormGroup>
                </BCol>
                <BCol>
                    <BFormGroup
                        label="Code *"
                        label-for="code"
                        class="text-start mb-3"
                    >
                        <BFormInput
                            v-model="form.code"
                            type="text"
                            id="code"
                            placeholder="Enter Code"
                            :class="{
                                'is-invalid':
                                    v$.form.code.$dirty &&
                                    v$.form.code.$invalid,
                            }"
                        />
                        <BFormInvalidFeedback
                            :state="
                                v$.form.code.$dirty && v$.form.code.$invalid
                            "
                        >
                            {{ v$.form.code.$errors[0]?.$message }}
                        </BFormInvalidFeedback>
                    </BFormGroup>
                </BCol>
            </BRow>
            <BRow>
                <BCol>
                    <BFormGroup
                        label="Room Type"
                        label-for="room_type"
                        class="text-start mb-3"
                    >
                        <BFormInput
                            v-model="form.room_type"
                            type="text"
                            id="room_type"
                            placeholder="Enter Room Type"
                            :class="{
                                'is-invalid':
                                    v$.form.room_type.$dirty &&
                                    v$.form.room_type.$invalid,
                            }"
                        />
                        <BFormInvalidFeedback
                            :state="
                                v$.form.room_type.$dirty &&
                                v$.form.room_type.$invalid
                            "
                        >
                            {{ v$.form.room_type.$errors[0]?.$message }}
                        </BFormInvalidFeedback>
                    </BFormGroup>
                </BCol>

                <BCol>
                    <BFormGroup
                        label="Extra Bed"
                        label-for="extra_bed"
                        class="text-start mb-3"
                    >
                        <BFormCheckbox
                            v-model="form.extra_bed"
                            :value="1"
                            :unchecked-value="0"
                            class="ml-1"
                            @change="handleExtraBedChange"
                            :class="{
                                'is-invalid':
                                    v$.form.extra_bed.$dirty &&
                                    v$.form.extra_bed.$invalid,
                            }"
                            >Extra Bed
                        </BFormCheckbox>
                        <BFormInvalidFeedback
                            :state="
                                v$.form.extra_bed.$dirty &&
                                v$.form.extra_bed.$invalid
                            "
                        >
                            {{ v$.form.extra_bed.$errors[0]?.$message }}
                        </BFormInvalidFeedback>
                    </BFormGroup>
                </BCol>
            </BRow>
            <BRow>
                <BCol>
                    <BFormGroup
                        label="Pax *"
                        label-for="pax"
                        class="text-start mb-3"
                    >
                        <BFormInput
                            v-model="form.pax"
                            type="number"
                            id="Pax"
                            placeholder="Enter Pax"
                            @update:modelValue="calculateSubtotal"
                            :class="{
                                'is-invalid':
                                    v$.form.pax.$dirty && v$.form.pax.$invalid,
                            }"
                        />
                        <BFormInvalidFeedback
                            :state="v$.form.pax.$dirty && v$.form.pax.$invalid"
                        >
                            {{ v$.form.pax.$errors[0]?.$message }}
                        </BFormInvalidFeedback>
                    </BFormGroup>
                </BCol>
                <BCol>
                    <BFormGroup
                        label="Price *"
                        label-for="price"
                        class="text-start mb-3"
                    >
                        <BFormInput
                            v-model="form.price"
                            type="number"
                            id="price"
                            placeholder="Enter Price"
                            @update:modelValue="calculateSubtotal"
                            :class="{
                                'is-invalid':
                                    v$.form.price.$dirty &&
                                    v$.form.price.$invalid,
                            }"
                        />
                        <BFormInvalidFeedback
                            :state="
                                v$.form.price.$dirty && v$.form.price.$invalid
                            "
                        >
                            {{ v$.form.price.$errors[0]?.$message }}
                        </BFormInvalidFeedback>
                    </BFormGroup>
                </BCol>
            </BRow>
            <BRow>
                <BCol>
                    <BFormGroup
                        label="Subtotal *"
                        label-for="sub_total"
                        class="text-start mb-3"
                    >
                        <BFormInput
                            v-model="form.sub_total"
                            type="number"
                            id="sub_total"
                            placeholder="Subtotal"
                            @update:modelValue="calculatePrice"
                        />
                    </BFormGroup>
                </BCol>
            </BRow>
            <template v-if="form.extra_bed == 1">
                <BRow>
                    <BCol>
                        <BFormGroup
                            label="Extra Bed Price *"
                            label-for="extra_bed_price"
                            class="text-start mb-3"
                        >
                            <BFormInput
                                v-model="form.extra_bed_price"
                                type="number"
                                id="extra_bed_price"
                                placeholder="Enter Price"
                                @update:modelValue="calculateTotal"
                                :class="{
                                    'is-invalid':
                                        v$.form.extra_bed_price.$dirty &&
                                        v$.form.extra_bed_price.$invalid,
                                }"
                            />
                            <BFormInvalidFeedback
                                :state="
                                    v$.form.extra_bed_price.$dirty &&
                                    v$.form.extra_bed_price.$invalid
                                "
                            >
                                {{
                                    v$.form.extra_bed_price.$errors[0]?.$message
                                }}
                            </BFormInvalidFeedback>
                        </BFormGroup>
                    </BCol>
                </BRow>
                <BRow>
                    <BCol>
                        <BFormGroup
                            label="Total Price *"
                            label-for="total_price"
                            class="text-start mb-3"
                        >
                            <BFormInput
                                v-model="form.total_price"
                                type="number"
                                id="total_price"
                                placeholder="Total Price"
                                disabled
                            />
                        </BFormGroup>
                    </BCol>
                </BRow>
            </template>
            <BRow>
                <BCol>
                    <BFormGroup
                        label="Inclusion"
                        label-for="inclusion"
                        class="text-start mb-3"
                    >
                        <BFormTextarea
                            v-model="form.inclusion"
                            id="inclusion"
                            placeholder="Enter Inclusion"
                            :rows="5"
                            :class="{
                                'is-invalid':
                                    v$.form.inclusion.$dirty &&
                                    v$.form.inclusion.$invalid,
                            }"
                        >
                        </BFormTextarea>
                        <BFormInvalidFeedback
                            :state="
                                v$.form.inclusion.$dirty &&
                                v$.form.inclusion.$invalid
                            "
                        >
                            {{ v$.form.inclusion.$errors[0]?.$message }}
                        </BFormInvalidFeedback>
                    </BFormGroup>
                </BCol>
            </BRow>
            <BRow>
                <BCol>
                    <BFormGroup
                        label="Exclusion"
                        label-for="exclusion"
                        class="text-start mb-3"
                    >
                        <BFormTextarea
                            v-model="form.exclusion"
                            id="exclusion"
                            placeholder="Enter Exclusion"
                            :rows="5"
                            :class="{
                                'is-invalid':
                                    v$.form.exclusion.$dirty &&
                                    v$.form.exclusion.$invalid,
                            }"
                        >
                        </BFormTextarea>
                        <BFormInvalidFeedback
                            :state="
                                v$.form.exclusion.$dirty &&
                                v$.form.exclusion.$invalid
                            "
                        >
                            {{ v$.form.exclusion.$errors[0]?.$message }}
                        </BFormInvalidFeedback>
                    </BFormGroup>
                </BCol>
            </BRow>
        </BForm>

        <template #footer>
            <div class="d-flex justify-content-end">
                <BButton variant="primary" class="me-2" @click="handleAction"
                    >Save</BButton
                >
                <BButton variant="danger" @click="updateModal(false)"
                    >Cancel</BButton
                >
            </div>
        </template>
    </BModal>
</template>

<script setup>
import axios from "axios";
import { defineProps, defineEmits, reactive, watch, ref, onMounted } from "vue";
import {
    BModal,
    BRow,
    BCol,
    BForm,
    BFormInput,
    BButton,
    BFormGroup,
    BFormInvalidFeedback,
    BFormCheckbox,
    BFormTextarea,
} from "bootstrap-vue-next";
import { useVuelidate } from "@vuelidate/core";
import {
    helpers,
    required,
    minValue,
    minLength,
    requiredIf,
} from "@vuelidate/validators";
import { useLoading } from "vue-loading-overlay";
import { useAuthStore } from "@/store/auth.js";
import { useToast } from "vue-toastification";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { parseRupiah } from "@/utils/format";

const auth = useAuthStore();
const $loading = useLoading();
const toast = useToast();

// Props
const props = defineProps({
    action: String,
    modal: Boolean,
    selectedData: Object,
});

// Emit
const emit = defineEmits(["update:modal", "addOrUpdate"]);

// Function to update modal visibility
const updateModal = (value) => {
    emit("update:modal", value); // Sync modal state with parent
};

const resetForm = () => {
    Object.assign(form, { ...formData });
    v$.value.$reset();
};
let selectedAccomodation = ref();

const formData = {
    destination_uuid: "",
    name: "",
    code: "",
    pax: "",
    price: "",
    sub_total: "",
    extra_bed: "",
    extra_bed_price: "",
    total_price: "",
    room_type: "",
    inclusion: "",
    exclusion: "",
};

const form = reactive({ ...formData });

// Init data jika update
watch(
    () => props.selectedData,
    (newData) => {
        if (newData && Object.keys(newData).length > 0) {
            const accomodationData = {
                ...newData,
                destination_uuid: newData.destination?.uuid || null,
                price: parseRupiah(newData.price),
                sub_total: parseRupiah(newData.sub_total),
                extra_bed_price: newData.extra_bed_price
                    ? parseRupiah(newData.extra_bed_price)
                    : null,
            };

            // Cari option di list
            const existingOption = accomodationList.value.find(
                (item) => item.uuid === accomodationData.uuid
            );

            if (existingOption) {
                selectedAccomodation.value = existingOption.uuid; // sesuai reduce
            } else {
                // Jika belum ada di list (misal data baru)
                const newOption = {
                    uuid: accomodationData.uuid ?? `new-${Date.now()}`,
                    name: accomodationData.name,
                    code: accomodationData.code ?? "",
                    destination: accomodationData.destination ?? null,
                };
                accomodationList.value.push(newOption);
                selectedAccomodation.value = newOption.uuid;
            }

            Object.assign(form, { ...accomodationData });
        } else {
            selectedAccomodation.value = null; // kosong untuk create baru
            Object.assign(form, { ...formData });
        }
    },
    { immediate: true }
);

// Watch for changes in pax and price to calculate subtotal
const calculateTotal = () => {
    const subTotal = parseFloat(form.sub_total) || 0;
    const extraBedPrice = form.extra_bed == 1 ? (parseFloat(form.extra_bed_price) || 0) : 0;
    form.total_price = subTotal + extraBedPrice;
};

const calculateSubtotal = () => {
    const pax = parseFloat(form.pax) || 0;
    const price = parseFloat(form.price) || 0;
    form.sub_total = pax * price;
    calculateTotal();
};

const calculatePrice = () => {
    const pax = parseFloat(form.pax) || 0;
    const subTotal = parseFloat(form.sub_total) || 0;

    if (pax && pax != 0 && subTotal) {
        form.price = subTotal / pax;
    } else if (pax == 0 && subTotal) {
        // can't divide by zero
    } else {
         if (!subTotal) {
            form.price = 0;
        }
    }
    calculateTotal();
};

const handleExtraBedChange = (val) => {
    if (val != 1) {
        form.extra_bed_price = 0;
    }
    calculateTotal();
};

const rules = {
    form: {
        destination_uuid: {
            required: helpers.withMessage("Destination is required", required),
        },
        name: {
            required: helpers.withMessage("Name is required", required),
            minLength: helpers.withMessage(
                "Name must be at least 3",
                minLength(3)
            ),
        },
        pax: {
            required: helpers.withMessage("Pax is required", required),
            minValue: helpers.withMessage(
                "Pax must be at least 1",
                minValue(1)
            ),
        },
        code: {
            required: helpers.withMessage("Code is required", required),
        },
        extra_bed: {},
        room_type: {
            // required: helpers.withMessage("Price is required", required),
        },
        price: {
            required: helpers.withMessage("Price is required", required),
            minValue: helpers.withMessage(
                "Price must be at least 1",
                minValue(1)
            ),
        },
        extra_bed_price: {
            requiredIf: helpers.withMessage(
                "Extra Bed Price is required",
                requiredIf(() => form.extra_bed == 1)
            ),
            minValue: helpers.withMessage(
                "Extra Bed Price must be at least 1",
                (value) => form.extra_bed != 1 || value >= 1
            ),
        },
        inclusion: {},
        exclusion: {},
    },
};

const v$ = useVuelidate(rules, { form });

const handleAction = () => {
    props.selectedData.uuid ? update() : create();
};

const create = async () => {
    v$.value.$touch();
    if (!v$.value.$invalid) {
        const loader = $loading.show({
            color: "#489464",
            loader: "spinner",
        });

        try {
            const response = await axios.post(
                `${process.env.VUE_APP_API_URL}/accomodation/add`,
                {
                    destination_uuid: form.destination_uuid,
                    name: form.name,
                    code: form.code,
                    extra_bed: form.extra_bed ?? 0,
                    room_type: form.room_type ?? "Standar",
                    pax: form.pax,
                    price: form.price,
                    sub_total: form.sub_total,
                    extra_bed_price: form.extra_bed_price ?? 0,
                    total_price: form.total_price ?? form.price,
                    inclusion: form.inclusion,
                    exclusion: form.exclusion,
                },
                {
                    headers: {
                        "Content-type": "application/json",
                        Authorization: "Bearer " + auth._token,
                    },
                }
            );

            const res = response.data;

            if (res.status) {
                emit("addOrUpdate");
                toast.success(res.message);
                updateModal(false);
                resetForm();
            }
        } finally {
            loader.hide();
        }
    }
};

const update = async () => {
    v$.value.$touch();
    if (!v$.value.$invalid) {
        const loader = $loading.show({
            color: "#489464",
            loader: "spinner",
        });
        try {
            const response = await axios.put(
                `${process.env.VUE_APP_API_URL}/accomodation/edit/${props.selectedData.uuid}`,
                {
                    destination_uuid: form.destination_uuid,
                    name: form.name,
                    code: form.code,
                    extra_bed: form.extra_bed ?? 0,
                    room_type: form.room_type ?? "Standar",
                    pax: form.pax,
                    price: form.price,
                    sub_total: form.sub_total,
                    extra_bed_price: form.extra_bed_price ?? 0,
                    total_price: form.total_price ?? form.price,
                    inclusion: form.inclusion,
                    exclusion: form.exclusion,
                },
                {
                    headers: {
                        "Content-type": "application/json",
                        Authorization: "Bearer " + auth._token,
                    },
                }
            );

            const res = response.data;

            if (res.status) {
                emit("addOrUpdate");
                toast.success(res.message);
                updateModal(false);
                resetForm();
            }
        } finally {
            loader.hide();
        }
    }
};

let destinationList = ref([]);

const getAllDestination = async () => {
    const loader = $loading.show({
        color: "#489464",
        loader: "spinner",
    });
    try {
        const response = await axios.get(
            `${process.env.VUE_APP_API_URL}/destination`,
            {
                headers: {
                    "Content-type": "application/json",
                    Authorization: "Bearer " + auth._token,
                },
            }
        );

        const res = response.data;

        if (res.status) {
            destinationList.value = res.data;
        }
    } finally {
        loader.hide();
    }
};

let accomodationList = ref([]);
let accomodationLoading = ref(false);
const getAllAccomodation = async () => {
    accomodationLoading.value = true;

    try {
        const response = await axios.get(
            `${process.env.VUE_APP_API_URL}/accomodation?unique=true`,
            {
                headers: {
                    "Content-type": "application/json",
                    Authorization: "Bearer " + auth._token,
                },
            }
        );

        const res = response.data;

        if (res.status) {
            // selectedAccomodation.value = null;
            accomodationList.value =
                res.data && res.data.length ? res.data : [];
        }
    } catch (e) {
        console.log(e);
    } finally {
        accomodationLoading.value = false;
    }
};

const getAccomodation = async (accommodation) => {
    form.name = accommodation.name ?? "";
    form.code = accommodation.code ?? "";
};

onMounted(() => {
    if (destinationList.value != null || destinationList.value != "") {
        getAllDestination();
    }
});
</script>
